import { dateFns } from 'iso-fns2'
import { isoZ, z } from 'my-zod'

export const customerWaiverSearchRequest = z
  .object({
    search: z.string().nullish(),
    startDate: isoZ.date().nullish(),
    endDate: isoZ.date().nullish(),
    operatorId: z.number().nullish(),
    vehicleId: z.number().nullish()
  })
  .setCFV({
    startAndEndDate(val) {
      if (val.startDate && !val.endDate) {
        return {
          message: 'Must supply end date if start date is supplied',
          path: ['endDate']
        }
      } else if (val.endDate && !val.startDate) {
        return {
          message: 'Must supply start date if end date is supplied',
          path: ['startDate']
        }
      } else if (val.startDate && val.endDate) {
        if (dateFns.isBefore(val.endDate, val.startDate)) {
          return {
            message: 'Must be after start date',
            path: ['endDate']
          }
        } else if (
          !val.vehicleId &&
          !val.operatorId &&
          dateFns.chain(val.startDate).until(val.endDate).getDays().value() >= 3
        ) {
          return {
            message: 'Date range must be less than 3 days if no vehicle or operator specified',
            path: ['endDate']
          }
        } else if (
          (val.vehicleId || val.operatorId) &&
          dateFns.chain(val.startDate).until(val.endDate).getDays().value() >= 32
        ) {
          return {
            message: 'Date range must be less than 32 days',
            path: ['endDate']
          }
        }
      } else if (val.search && val.search.length < 3) {
        return {
          message: 'Should be at least 3 characters',
          path: ['search']
        }
      }
    }
  })
